import { CreditViewMode } from "@custom-types/credit-types";
import { Stack, Typography } from "@mui/material";
import { CreditsDialog } from "@pages/settings/subscription-settings/credits/credits-dialog";
import { NewCreditIndication } from "@pages/settings/subscription-settings/credits/new-credit-indication";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { formatNumber } from "@utils/data-display";

interface Props {
  /** Show the credit balance */
  creditBalance: number;
}

/**
 * Displays the user's credit(token) balance along with an action button to view transactions.
 *
 * This component shows the current credit balance and provides a button to navigate
 * to the credit transactions page. When the button is clicked, an event is tracked
 * for analytics purposes.
 */
export function CreditsBalanceItem({ creditBalance }: Props): JSX.Element {
  return (
    <Stack
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <Stack flexDirection="row" alignItems="start">
        <Typography data-testid="credits-balance-item-balance">
          <var>{formatNumber(creditBalance)}</var> {CREDITS_DISPLAY_NAME}
        </Typography>

        <NewCreditIndication />
      </Stack>

      <CreditsDialog
        buttonLabel="View transactions"
        initialViewMode={CreditViewMode.transaction}
      />
    </Stack>
  );
}
